import type { Film } from "@/types/content";

export default function PosterCard({ film }: { film: Film }) {
  return (
    <a
      href="#library"
      className="group block cursor-pointer"
      aria-label={`${film.title} (${film.year})`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-foreground-900">
        <img
          src={film.image}
          alt={`${film.title} poster`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        {film.isNew && (
          <span className="absolute top-3 left-3 rounded-full bg-accent-500 px-2.5 py-1 font-label text-[10px] tracking-[0.16em] uppercase text-primary-950">
            New
          </span>
        )}

        <div className="absolute inset-x-0 bottom-0 p-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <p className="text-xs text-background-200/90 line-clamp-2">{film.tagline}</p>
          <span className="mt-2 inline-flex items-center gap-1.5 font-label text-[11px] tracking-[0.16em] uppercase text-accent-400">
            <i className="ri-play-circle-fill text-base"></i>
            Details
          </span>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 leading-tight group-hover:text-primary-500 transition-colors">
          {film.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {film.genre} · {film.year}
        </p>
      </div>
    </a>
  );
}